import React from 'react';
import { motion } from 'framer-motion';

const networks = [
  { name: 'Ethereum', symbol: 'ETH', color: '#627EEA' },
  { name: 'BNB Chain', symbol: 'BNB', color: '#F3BA2F' },
  { name: 'Polygon', symbol: 'MATIC', color: '#8247E5' },
  { name: 'Arbitrum', symbol: 'ARB', color: '#28A0F0' },
  { name: 'Optimism', symbol: 'OP', color: '#FF0420' },
  { name: 'Avalanche', symbol: 'AVAX', color: '#E84142' },
  { name: 'Fantom', symbol: 'FTM', color: '#1969FF' },
  { name: 'Base', symbol: 'BASE', color: '#0052FF' },
  { name: 'zkSync', symbol: 'ZK', color: '#8B8DFC' },
  { name: 'Linea', symbol: 'LINEA', color: '#61DFFF' },
];

const NetworkMarquee = () => {
  // Duplicate for seamless loop
  const duplicatedNetworks = [...networks, ...networks];

  return (
    <div className="relative overflow-hidden py-8 bg-[var(--bg-surface-1)]" data-testid="network-marquee">
      <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-[var(--bg-surface-1)] to-transparent z-10" />
      <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-[var(--bg-surface-1)] to-transparent z-10" />
      
      <motion.div
        className="flex gap-8"
        animate={{ x: [0, -50 * networks.length] }}
        transition={{
          duration: 20,
          repeat: Infinity,
          ease: "linear",
        }}
      >
        {duplicatedNetworks.map((network, index) => (
          <div
            key={`${network.symbol}-${index}`}
            className="flex items-center gap-3 px-6 py-3 rounded-xl bg-[var(--bg-surface-2)] border border-[var(--border-default)] whitespace-nowrap"
          >
            <div 
              className="w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold"
              style={{ backgroundColor: `${network.color}20`, color: network.color }}
            >
              {network.symbol.slice(0, 2)}
            </div>
            <span className="font-medium text-[var(--text-primary)]">{network.name}</span>
          </div>
        ))}
      </motion.div>
    </div>
  );
};

export default NetworkMarquee;
